export default __webpack_public_path__ + "static/Henna-b927d8291f123e89301fa610672f0677.png";